import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';

import { IListFetcher } from '../../httpClient/fetchers/IListFetcher';
import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { IListResource } from '../../httpClient/resources/Resource';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { IDatabaseInfo } from '../models/IDatabaseInfo';
import { GetDatabasesRequest } from '../serverApi/requests/databases/GetDatabasesRequest';


class DatabasesWithCrassResource implements IListResource<IDatabaseInfo> {

  private listFetcher: IListFetcher<IDatabaseInfo> = new WebClientListResourceFetcher(GetDatabasesRequest, ServerApiMapper.databasesUsingCrass);

  public all(): ResourceQuery<IDatabaseInfo> {
    return new ResourceQuery(this.listFetcher);
  }

}

export const DatabasesWithCrass = new DatabasesWithCrassResource();
export type DatabasesWithCrass = typeof DatabasesWithCrass;
